import { WS_ON_MESSAGE, WS_ON_MESSAGE_EVENT_CONFIRMED } from '../Types/Websocket';
import { READ_LEADERBOARD_SUCCESS } from '../Types/Leaderboard';

const LeaderboardReducer = (state = {}, action = {}, confirmed=[]) => {
    switch (action.type) {
        case WS_ON_MESSAGE:

            console.log("LeaderboardReducer WS_ON_MESSAGE", action.payload);

            if (action.payload.indexOf("type") > 0) {

                let item = JSON.parse(action.payload);

                var leaderboard = state.leaderboard;

                if (!leaderboard) {
                    leaderboard = new Object();
                }

                if (!leaderboard.events) {
                    leaderboard.events = [];
                }
                leaderboard.events.unshift(item);
                return { ...state, last: item, leaderboard: leaderboard }
            } else {
                return state;
            }
        case WS_ON_MESSAGE_EVENT_CONFIRMED:
            var conf  = state.confirmed;
            let confMessage = JSON.parse(action.payload);

            if (!conf) {
                conf = new Object();
            }
            if (!conf.confirmed) {
               conf.confirmed = [];}
            console.log("CONF: ", conf);
conf.confirmed.unshift(confMessage)
            console.log("CONFIRMED: ", confMessage);
            return {
             ...state, confirmed:conf}
             // ...state,
             // confirmed: [...state.confirmed, conf]
           //   confirmed: confirmed.concat(confMessage)
          // }
        case READ_LEADERBOARD_SUCCESS:
            let leaderboard = action.payload.leaderboard;
            if (!leaderboard) {
                console.log("No leaderboard found", action.payload);
                return state;
            }
            let item = leaderboard.events ? leaderboard.events[0] : null;
            return { ...state, leaderboard: leaderboard, last: item }
        default:
            return state;
    }
};

export default LeaderboardReducer;



// WEBPACK FOOTER //
// ./src/Reducers/LeaderboardReducer.js